import React from 'react';

import { Button } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../features/track';
import { addAccountUrl } from '../../../Shared/addAccountUrl';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { AccountRecommendationOptionQuery } from '../graphql/query.accountRecommendationOption.generated';

type AccountRecommendationOption = NonNullable<AccountRecommendationOptionQuery['accountRecommendationOption']>;
type AccountRecommendation = NonNullable<AccountRecommendationOption['recommendation']>;
type Option = AccountRecommendation['productOnboardingOption'];

export const OpenAccountButton: React.FC<{ option: Option }> = ({ option }) => {
  const linkDetails = (() => {
    if (option.__typename === 'GoalCreationOption') {
      const url = addAccountUrl({ product_category: option.legacyProductCategory });
      return { url, text: 'Open this account' };
    }

    if (option.__typename === 'CheckingAccountCreationOption') {
      return { url: urlBuilder.getAppCheckingAbout.absolute(), text: 'Open this account' };
    }

    if (option.__typename === 'Solo401kOnboardingOption') {
      const pc = option.legacyProductCategory;
      const url = urlBuilder.appAdviceInitiationFlow.absolute({ signup_intent: pc, product_category: pc });
      return { url, text: 'Get started' };
    }

    return null;
  })();

  if (!linkDetails) return null;

  return (
    <SambaAutoLink
      to={linkDetails.url}
      onClick={() =>
        trackClick({
          name: 'OpenAccount',
          module: 'AccountRecommendation',
          recommendation: option.name,
        })
      }
    >
      <Button variant="solidPrimary">{linkDetails.text}</Button>
    </SambaAutoLink>
  );
};
